<app-loading *ngIf="!promo_codes; else promoLoaded"></app-loading>
<ng-template #promoLoaded>
    <app-public-information-page *ngIf="!promo_code; else promoCodeExist"
        [message_mode]="message_mode"></app-public-information-page>
    <ng-template #promoCodeExist>
        <app-navbar class="home"></app-navbar>
        <div class="promo-code-landing-wrapper">
            <div class="container">
                <section class="promo-code-landing-banner">
                    <div class="promo-code-landing-code-parent d-flex flex-column py-5">
                        <app-countdown [end_date]="promo_code.end_date" (reached)="changePromoCode()"></app-countdown>
                        <div class="pclcp-code d-flex flex-row">
                            <div class="flex-grow-1 fs-3 fw-bolder text-primary text-center">
                                {{promo_code.code}}
                            </div>
                            <div class="pclcp-copy">
                                <i class="bi bi-copy mouse-pointer"
                                    (click)="functionService.copyToClipboard(promo_code.code)"></i>
                            </div>
                        </div>
                        <p class="mt-3 fs-5 text-center">{{promo_code.title}}</p>
                        <p class="mb-3 mt-n2 text-center" *ngIf="promo_code.tnc">
                            <u><i class="small mouse-pointer" (click)="openModal('tncModal')">Terms & Conditions
                                    apply!</i></u>
                        </p>
                        <a class="btn btn-secondary" routerLink="/pricing">
                            Get Started
                            <i class="bi bi-arrow-right ms-2"></i>
                        </a>
                        <p class="mt-3 text-center" *ngIf="!coreService.isLoggedIn()">
                            Don’t have an account yet? Click here to <a routerLink="/auth/signup">sign up</a>!
                        </p>
                    </div>
                </section>
            </div>
        </div>

        <div class="container">
            <section class="landing-contents">
                <div class="row my-5">
                    <div class="col-md-12 text-center pt-5">
                        <h1>Last Chance! Grab Your Exclusive Discount!</h1>
                        <p>At BrandQRcodes.com, we believe in making your online presence uniquely yours. Our platform
                            empowers you to create QR-accessible web pages with custom designs that reflect your brand's
                            personality and captivate your audience. We understand that achieving your vision should
                            also be budget-friendly, which is why we are excited to offer you exclusive discount codes
                            that help you save while you create stunning QR code pages.</p>
                        <a class="btn btn-secondary-light" routerLink="/pricing">
                            Get Started
                            <i class="bi bi-arrow-right ms-2"></i>
                        </a>
                    </div>
                </div>
                <app-shared-how-it-works content="discount"></app-shared-how-it-works>
                <br>
                <app-shared-why-choose-us></app-shared-why-choose-us>
                <div class="row my-5">
                    <div class="col-md-12 text-center">
                        <div class="mb-3 fs-3">
                            Have questions? Feel free to reach out to our support team for more information.
                        </div>
                        <a class="btn btn-secondary-light" routerLink="/contact-us">
                            <i class="bi bi-envelope me-2"></i>
                            Contact us</a>
                    </div>
                </div>
                <br>
                <br>
            </section>
        </div>

        <app-footer
            footer_text="Elevate your brand’s digital presense with BrandQRcodes.com - where innovation, affordability, and unique branding converge effortlessly."></app-footer>
    </ng-template>
</ng-template>

<!-- TnC Modal -->
<div class="modal fade" id="tncModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content" *ngIf="promo_code">
            <div class="modal-body py-4">
                <div class="text-center">
                    <div class="icon-bg mb-3">
                        <i class="bi bi-gear-wide-connected"></i>
                    </div>
                    <b>Terms & Conditions</b>
                </div>
                <p class="mt-2" [innerHTML]="promo_code.tnc"></p>
                <button type="button" class="btn btn-outline-secondary w-100" data-bs-dismiss="modal">Okay</button>
            </div>
        </div>
    </div>
</div>